import type { CropDefinition, CropId } from "./types";

export const CROP_ORDER: CropId[] = [
  "pumpkin",
  "coconut",
  "wintermelon",
  "banana",
  "moonherb",
  "carrot",
  "chili",
];

export const CROPS: Record<CropId, CropDefinition> = {
  carrot: {
    id: "carrot",
    name: "晨露胡萝卜",
    seedName: "萝卜籽",
    epithet: "速生 · 游击",
    description:
      "短周期、留种多。唤醒为灵巧斥候，远程射击；附身灵技射出穿透根矢。",
    icon: "萝",
    primary: "#efaa5b",
    secondary: "#d5f3a0",
    growSeconds: 36,
    waterUse: 0.012,
    foodYield: 3,
    seedYield: 3,
    awakenCost: 1,
    companionName: "根矢斥候",
    companionRole: "远程游击 · 擅长采野莓",
    companionHp: 85,
    companionDamage: 15,
    companionSpeed: 150,
    workKind: "berry",
  },
  chili: {
    id: "chili",
    name: "焰心辣椒",
    seedName: "焰椒籽",
    epithet: "高肥 · 爆发",
    description:
      "耐旱耗肥，收获少而灵力强。唤醒为焰椒术士；附身灵技以烈焰打断一片敌人。",
    icon: "椒",
    primary: "#ed6853",
    secondary: "#ffda83",
    growSeconds: 66,
    waterUse: 0.006,
    foodYield: 3,
    seedYield: 2,
    awakenCost: 2,
    companionName: "焰椒术士",
    companionRole: "中程爆发 · 烈焰打断",
    companionHp: 100,
    companionDamage: 23,
    companionSpeed: 103,
  },
  pumpkin: {
    id: "pumpkin",
    name: "赤纹南瓜",
    seedName: "南瓜籽",
    epithet: "烈性 · 近战",
    description: "喜肥耐旱。成熟后果肉充盈，唤灵则成为挥舞藤斧的强健战士。",
    icon: "瓜",
    primary: "#e79745",
    secondary: "#f3c45e",
    growSeconds: 54,
    waterUse: 0.008,
    foodYield: 5,
    seedYield: 2,
    awakenCost: 1,
    companionName: "南瓜刀斧手",
    companionRole: "近战先锋 · 对雾蚀兽造成高伤害",
    companionHp: 150,
    companionDamage: 27,
    companionSpeed: 108,
  },
  coconut: {
    id: "coconut",
    name: "清露椰苗",
    seedName: "椰芽",
    epithet: "续航 · 供给",
    description: "生长稍慢，喜水。唤灵后会在安稳时结出椰露，持续补给庭园。",
    icon: "椰",
    primary: "#9bc86a",
    secondary: "#d6dc86",
    growSeconds: 70,
    waterUse: 0.011,
    foodYield: 6,
    seedYield: 1,
    awakenCost: 1,
    companionName: "椰露侍从",
    companionRole: "后勤供给 · 闲置时周期产出食物",
    companionHp: 120,
    companionDamage: 12,
    companionSpeed: 92,
  },
  wintermelon: {
    id: "wintermelon",
    name: "霜甲冬瓜",
    seedName: "冬瓜籽",
    epithet: "坚韧 · 破岩",
    description: "水分稳定时长势最佳。厚重果壳可化作铁拳，尤其擅长击碎岩石。",
    icon: "冬",
    primary: "#6bb58b",
    secondary: "#a8d4aa",
    growSeconds: 62,
    waterUse: 0.009,
    foodYield: 5,
    seedYield: 2,
    awakenCost: 1,
    companionName: "冬瓜磐卫",
    companionRole: "重装破岩 · 采石效率极高",
    companionHp: 190,
    companionDamage: 22,
    companionSpeed: 78,
    workKind: "rock",
  },
  banana: {
    id: "banana",
    name: "风叶芭蕉",
    seedName: "芭蕉芽",
    epithet: "轻捷 · 伐木",
    description: "成长迅速但怕旱。叶刃灵巧，唤灵后能迅速收集林木与散落物。",
    icon: "蕉",
    primary: "#bcd85f",
    secondary: "#e8e589",
    growSeconds: 44,
    waterUse: 0.013,
    foodYield: 4,
    seedYield: 3,
    awakenCost: 1,
    companionName: "芭蕉叶刃",
    companionRole: "敏捷采集 · 伐木效率极高",
    companionHp: 95,
    companionDamage: 16,
    companionSpeed: 138,
    workKind: "tree",
  },
  moonherb: {
    id: "moonherb",
    name: "月露灵草",
    seedName: "月露孢子",
    epithet: "稀有 · 辅助",
    description: "需要细致照料的灵性作物。高品质收获有机会凝结额外灵露。",
    icon: "月",
    primary: "#a896d8",
    secondary: "#d6ccff",
    growSeconds: 78,
    waterUse: 0.007,
    foodYield: 2,
    seedYield: 1,
    awakenCost: 2,
    companionName: "月露医官",
    companionRole: "灵性辅助 · 跟随时缓慢治疗友军",
    companionHp: 105,
    companionDamage: 9,
    companionSpeed: 103,
  },
};

export const STAGE_LABELS = {
  empty: "空置",
  seed: "孕种",
  sprout: "破土",
  leaf: "展叶",
  flower: "蕴实",
  mature: "成熟",
} as const;

export const QUALITY_LABELS = ["粗朴", "清润", "上品", "灵辉"] as const;
